import { render, staticRenderFns } from "./group-form.vue?vue&type=template&id=58ea53b9&scoped=true&lang=pug&"
import script from "./group-form.vue?vue&type=script&lang=js&"
export * from "./group-form.vue?vue&type=script&lang=js&"
import style0 from "./group-form.vue?vue&type=style&index=0&id=58ea53b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ea53b9",
  null
  
)

export default component.exports